import React, { useState } from "react";
import { getPrincipaleOPrimoMacroGruppo } from "../../data/utils";
import AggsContainer from "./AggsContainer";
import MacrosContainer from "./MacrosContainer";
import './PrematchBetGroupsNewAlt.css'

function PrematchBetGroupsNewAlt(props) {
    const [isExpandedMacro, setIsExpandedMacro] = useState(false);
    const [isExpandedAggregate, setIsExpandedAggregate] = useState(true);
    let macrogruppo = props.macrogruppo;
    
    if (props.macrogruppi.length > 0 && macrogruppo == null) {
        macrogruppo = getPrincipaleOPrimoMacroGruppo(props.macrogruppi);
    }
    
    const gruppiScommessa =
    macrogruppo != null ? macrogruppo.aggregate : props.aggregate;
    
    if (props.macrogruppi.length <= 1 && gruppiScommessa.length <= 1) {
        return null;
    }
    
    return (
        <div className="prematchbetgroupsnewalt__container">
            <div className={`macrogruppi-wrapper mb-2 ${isExpandedMacro ? "expanded" : "scrollable"}`} id="macro__wrapper">
                {props.macrogruppi.length > 1 &&
                    <>
                        <MacrosContainer
                            current={macrogruppo.id}
                            macros={props.macrogruppi}
                            onClick={props.changeMacrogruppo}
                        />
                        {/* {!isExpandedMacro && <div className="scroll-right-gradient" />} */}
                        <div className="toggle-view-btn" onClick={() => setIsExpandedMacro(!isExpandedMacro)}></div>
                    </>
                }
            </div>
            <div className={`macro-gruppi mb-2 ${isExpandedAggregate ? "expanded" : "scrollable"}`} id="aggregate__wrapper">
                {gruppiScommessa.length > 1 &&
                    <>
                        <AggsContainer
                            current={props.aggregata}
                            aggs={gruppiScommessa}
                            onClick={props.changeAggregata}
                        />
                        {/* {!isExpandedAggregate && <div className="scroll-right-gradient" />} */}
                        <div className="toggle-view-btn" onClick={() => setIsExpandedAggregate(!isExpandedAggregate)}></div>
                    </>
                }
            </div>
        </div>
    );
}

export default PrematchBetGroupsNewAlt;
